module.exports = __webpack_public_path__ + "img/facebook_c.f677768e.svg";